/**
 * Probe whether an embed URL is reachable from the browser.
 * Connection failures reject fetch even with mode: 'no-cors';
 * a successful opaque response means the host answered.
 */
export async function probeEmbedUrl(url, timeoutMs = 4000) {
  if (!url || typeof window === 'undefined') return false;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    await fetch(url, {
      method: 'GET',
      mode: 'no-cors',
      cache: 'no-store',
      signal: controller.signal,
    });
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
